import React from 'react';
import { Users, Swords, BarChart3, ListChecks, Trophy, ArrowRight } from 'lucide-react';

const LandingPage = ({ onLogin }) => {
  const features = [
    { icon: <Users className="w-8 h-8 mb-4 text-emerald-400" />, title: 'Gerenciamento de Jogadores', description: 'Adicione, renomeie e remova jogadores de forma simples e rápida.' },
    { icon: <ListChecks className="w-8 h-8 mb-4 text-emerald-400" />, title: 'Geração Inteligente de Partidas', description: 'Crie confrontos balanceados com base no número de partidas por jogador.' },
    { icon: <Swords className="w-8 h-8 mb-4 text-emerald-400" />, title: 'Placar em Tempo Real', description: 'Marque os pontos e veja os resultados das partidas ao vivo.' },
    { icon: <BarChart3 className="w-8 h-8 mb-4 text-emerald-400" />, title: 'Ranking Automático', description: 'A classificação é atualizada instantaneamente após cada jogo.' },
    { icon: <Trophy className="w-8 h-8 mb-4 text-emerald-400" />, title: 'Histórico de Torneios', description: 'Salve e consulte o desempenho em torneios anteriores.' },
  ];

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 font-sans animate-in fade-in duration-1000">
      {/* Header */}
      <header className="container mx-auto px-6 py-6 flex justify-between items-center">
        <div className="flex items-center gap-3">
          <Trophy className="w-7 h-7 text-emerald-400" />
          <h2 className="font-black text-2xl text-slate-200">PoolDraw</h2>
        </div>
        <button 
          onClick={onLogin}
          className="bg-slate-800 hover:bg-slate-700 text-slate-300 font-bold py-2 px-5 rounded-full transition-all text-sm flex items-center gap-2"
        >
          Login <ArrowRight className="w-4 h-4" />
        </button>
      </header>

      <div className="container mx-auto px-6">
        {/* Hero Section */}
        <section className="text-center py-20 md:py-32">
          <h1 className="text-5xl md:text-7xl font-black text-slate-100 mb-6 leading-tight">
            O jeito mais fácil de <span className="text-emerald-400">gerenciar</span> seus torneios de Sinuca.
          </h1>
          <p className="max-w-2xl mx-auto text-lg text-slate-400 mb-10">
            Chega de planilhas complicadas! Crie, gerencie e acompanhe seus torneios de forma simples e intuitiva, com rankings e partidas em tempo real.
          </p>
          <button 
            onClick={onLogin} 
            className="bg-emerald-500 hover:bg-emerald-400 text-slate-950 font-black py-4 px-10 rounded-full transition-all text-xl shadow-2xl shadow-emerald-500/30 transform hover:scale-105"
          >
            Comece Agora (É Grátis!)
          </button>
        </section>

        {/* Features Section */}
        <section className="py-20">
          <h2 className="text-4xl font-black text-center text-slate-100 mb-16">Funcionalidades Incríveis</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <div key={index} className="bg-slate-900 border border-slate-800 p-8 rounded-3xl transform hover:-translate-y-2 transition-transform duration-300 shadow-xl hover:shadow-emerald-500/10">
                {feature.icon}
                <h3 className="font-bold text-xl text-slate-200 mb-3">{feature.title}</h3>
                <p className="text-slate-400">{feature.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* How it works */}
        <section className="py-20">
          <div className="bg-slate-900 border border-slate-800 p-10 md:p-16 rounded-3xl">
            <h2 className="text-4xl font-black text-center text-slate-100 mb-16">Como Funciona?</h2>
            <ol className="flex flex-col md:flex-row justify-around items-center text-center gap-12">
              <li className="flex-1">
                <div className="text-emerald-400 font-black text-6xl mb-2">1</div>
                <p className="font-bold text-slate-200">Adicione os jogadores ao torneio.</p>
              </li>
              <li className="flex-1">
                <div className="text-emerald-400 font-black text-6xl mb-2">2</div>
                <p className="font-bold text-slate-200">Defina o número de partidas por jogador.</p>
              </li>
              <li className="flex-1">
                <div className="text-emerald-400 font-black text-6xl mb-2">3</div>
                <p className="font-bold text-slate-200">Gere o torneio e comece a jogar!</p>
              </li>
            </ol>
          </div>
        </section>
      </div>
      
      {/* Footer */}
      <footer className="text-center py-8 mt-16 border-t border-slate-800">
        <p className="text-slate-500">PoolDraw. Simples e Poderoso.</p>
      </footer>
    </div>
  );
};

export default LandingPage;
